const workerUrl = new URL('./test.worker.js', import.meta.url);

export const ObjectToArray = (workerStatic , pureData ,setWorker, call) => {

  if (workerStatic) {
    workerStatic.terminate();
    workerStatic = new Worker(workerUrl);
    setWorker(workerStatic);
    workerStatic.postMessage(pureData);
    workerStatic.addEventListener("message", (event) => {
      call(event.data);
    });
  } else {
    workerStatic = new Worker(workerUrl);
    setWorker(workerStatic);
    workerStatic.postMessage(pureData);
    workerStatic.addEventListener("message", (event) => {
      call(event.data);
    });
  }
};
